import { render, staticRenderFns } from "./UmanjeniSatEdit.vue?vue&type=template&id=5d13bca7&scoped=true&"
import script from "./UmanjeniSatEdit.vue?vue&type=script&lang=js&"
export * from "./UmanjeniSatEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d13bca7",
  null
  
)

export default component.exports